import BaseServiceCrud from './BaseServiceCrud';

export default class AutoRegistrationService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'autoregistration';
    }

    registrationAgreementTypes() {
        return this.fetch(`${this.domain}/${this.path}/registrationAgreementTypes`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    checkPromoCode(code) {
        return this.fetch(`${this.domain}/${this.path}/registrationCheckCode/${code}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    registrationValidateCustomerAndEmail(tin, email) {
        return this.fetch(`${this.domain}/${this.path}/registrationValidateCustomerAndEmail?tin=${tin}&email=${email}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    registrationStart(translate) {
        return this.fetch(`${this.domain}/${this.path}/registrationStart`, {
            method: 'POST',
        }).then((res) => {
            if (res.tradeList) {
                res.tradeList.forEach((el) => {
                    el.label = translate(`autoRegistration.trade.${el.sapCode}`);
                });
            }
            if (res.companyStatus) {
                res.companyStatus.forEach((el) => {
                    el.label = translate(`autoRegistration.CompanyStatus.${el.id}`);
                });
            }
            return Promise.resolve(res);
        });
    }

    completeRegistration(element, emailStatementFile, registrationStatementFile, krsFile) {
        
        const formData = new FormData();
        if (emailStatementFile !== null && emailStatementFile !== undefined) {
                    formData.append('emailStatementFile', emailStatementFile);
                    formData.append('emailStatementFileName', emailStatementFile.name);
                }
                if (registrationStatementFile !== null && registrationStatementFile !== undefined) {
                    formData.append('registrationStatementFile', registrationStatementFile);
                    formData.append('registrationStatementFileName', registrationStatementFile.name);
                }
                if (krsFile !== null && krsFile !== undefined) {
                    formData.append('krsFile', krsFile);
                    formData.append('krsFileName', krsFile.name);
                }
                formData.append('body', new Blob([JSON.stringify(element)], {
                    type: 'application/json'
              }));
                
        return this.fetch(`${this.domain}/${this.path}/completeRegistration`, {
            method: 'POST',
            body: formData,
        },
        {
            Accept: 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
        }
    ).then((res) => {
            return Promise.resolve(res);
        });
    }
//before:

// completeRegistration(element) {
//     return this.fetch(`${this.domain}/${this.path}/completeRegistration`, {
//         method: 'POST',
//         body: JSON.stringify(element),
//     }).then((res) => {
//         return Promise.resolve(res);
//     });
// }


    getApprovals(agreementType) {
        return this.fetch(`${this.domain}/${this.path}/approvals/${agreementType}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    saveFlatRateFarmerStatement(element){
        return this.fetch(`${this.domain}/${this.path}/flatRateFarmerStatement`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    
    registrationByBankFirstForm(element) {
        return this.fetch(`${this.domain}/${this.path}/bankRegistrationFirstStep`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    verifyTin(tin) {
        return this.fetch(`${this.domain}/${this.path}/verify/${tin}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    verifyClientAgreementSent(tin) {
        return this.fetch(`${this.domain}/${this.path}/verify-agreements/${tin}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getHybridApprovals() {
        return this.fetch(`${this.domain}/${this.path}/approvals/hybrid`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
